import {
  Box,
  Button,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import {
  Show,
  SimpleShowLayout,
  TextField,
  FunctionField,
  useRecordContext,
  useRedirect,
} from "react-admin";
import GroupIcon from "@mui/icons-material/Group";
import AddIcon from "@mui/icons-material/Add";
import { MemberList } from "./member-list";

const SubGroupList = () => {
  const record = useRecordContext();
  const redirect = useRedirect();

  if (!record || !record.subGroups) return null;

  console.log("record", record.id);

  const handleAddDepartment = () => {
    // 处理添加部门的逻辑，例如重定向到添加部门的页面
    redirect(`/groups/create?parentId=${record.id}`);
  };

  return (
    <Box>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Typography variant="body2">部门：</Typography>
        <Button
          onClick={handleAddDepartment}
          color="primary"
          startIcon={<AddIcon />}
        >
          添加部门
        </Button>
      </Box>
      {record.subGroups.map((subGroup: any) => (
        <ListItemButton
          key={subGroup.id}
          onClick={() => redirect(`/groups/${subGroup.id}/show`)}
        >
          <ListItemIcon>
            <GroupIcon />
          </ListItemIcon>
          <ListItemText primary={subGroup.name} />
        </ListItemButton>
      ))}
    </Box>
  );
};

export const GroupShow = (props: any) => {
  return (
    <Show {...props}>
      <SimpleShowLayout>
        <TextField source="name" label="组名" />
        <TextField source="path" label="路径" />
        <FunctionField
          label="子部门数量"
          render={(record: any) => record.subGroupCount ?? 0}
        />
        <SubGroupList />
        <FunctionField
          label="属性"
          render={(record: any) =>
            record.attributes && Object.keys(record.attributes).length > 0
              ? JSON.stringify(record.attributes)
              : "无"
          }
        />
        <FunctionField
          label="领域角色"
          render={(record: any) =>
            record.realmRoles && record.realmRoles.length > 0
              ? record.realmRoles.join(", ")
              : "无"
          }
        />
        <FunctionField
          label="客户端角色"
          render={(record: any) =>
            record.clientRoles && Object.keys(record.clientRoles).length > 0
              ? JSON.stringify(record.clientRoles)
              : "无"
          }
        />
        <FunctionField
          label="访问权限"
          render={(record: any) =>
            record.access
              ? `查看: ${record.access.view ? "是" : "否"}, 查看成员: ${
                  record.access.viewMembers ? "是" : "否"
                }, 管理成员: ${
                  record.access.manageMembers ? "是" : "否"
                }, 管理: ${record.access.manage ? "是" : "否"}, 管理成员资格: ${
                  record.access.manageMembership ? "是" : "否"
                }`
              : "无"
          }
        />
        <MemberList />
      </SimpleShowLayout>
    </Show>
  );
};
